export const getNameInitials = function (fullName) {
  if (fullName === void 0) {
    fullName = '';
  }
  return fullName.trim().split(/\s+/).filter(Boolean).slice(0, 2).map(name => name[0].toUpperCase()).join('');
};
//# sourceMappingURL=getNameInitials.js.map